import BinarySearchTree from './BinarySearchTree';

export default BinarySearchTree;
